
import { gridSize, gridSizeMdLg12 } from "@/shared";
import { Button, Grid, InputAdornment, TextField, } from "@mui/material";
import { useState } from "react";
import { ScrollableDialogProps } from "./Dialogs";

export type ModalObservacionNoFormProps = {
  label: string;
  texto: string;
  title: string;
  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };
  numbertextPreview:number
  //isOpen?: boolean
}
export default function ModalObservacionNoForm({ texto, title, label, size = gridSize, numbertextPreview = 3 }: Readonly<ModalObservacionNoFormProps>) {

  const [isOpenModal, setIsOpenModal] = useState(false)
  //const textoResumida = texto.split(' ').slice(0, 2).join(' ') + '...'
  // Cortar a 20 caracteres + puntos suspensivos
  const textoResumida = texto.length > numbertextPreview ? texto.substring(0, numbertextPreview) + '...' : texto;
  return (
    <>

      <Grid item {...size}>
        {
          texto.length <= 26 ? (
            <TextField
              label={label}
              value={texto}
              variant="outlined"
              //InputProps={{ readOnly: true }}
              fullWidth
              multiline
            />
          ) : (


            <TextField
              label={label}
              value={textoResumida}
              variant="outlined"
              // InputProps={{ readOnly: true }}
              fullWidth
              rows={1}
              multiline
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Button
                      size="small"
                      onClick={() => setIsOpenModal(true)}
                      variant="text"
                    >
                      {'Ver todo'}
                    </Button>
                  </InputAdornment>
                ),
                readOnly: true
              }}
            />

          )
        }
      </Grid>
      {isOpenModal && (
        <ScrollableDialogProps
          open={isOpenModal}
          title={title}
          onCloseIcon={() => setIsOpenModal(false)}
          minWidth="48%"
          contentNode={
            <Grid container spacing={2}>
              <Grid item {...gridSizeMdLg12}>
                {/* <Typography>{texto}</Typography> */}
                <TextField
                  label={label}
                  value={texto}
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={6}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

            </Grid>
          }
        />
      )}
    </>
  )
}